import React from "react";
import classnames from "classnames";

import { ViewOfTheRoom } from "../../api";

interface ValueInTheRoomListProps {
  view: ViewOfTheRoom;
}

const ValueInTheRoomList = ({ view }: ValueInTheRoomListProps) => {

  return (
    <div className="bg-panel-light border-top">
      <div className="scroll scroll-auto custom-scrollbar">
        {view.data.map(
          (item, i) => (
            <div
              key={i}
              className={classnames({
                "border-top": 0 < i,
              })}
            >
              <div
                className="d-flex align-items-center justify-content-between px-3 py-1"
              >
                <div className="pr-2">{item.name}</div>
                <div className="text-nowrap">
                  {item.values[0]}
                  {!!view.suffix && (
                    <span>{view.suffix}</span>
                  )}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ValueInTheRoomList;
